// extracted by mini-css-extract-plugin
export default {"title":"BasicInfoCard_title__GX5-Q","value":"BasicInfoCard_value__WTq-u","valueTxt":"BasicInfoCard_valueTxt__MW7Ar"};